const getFormattedPaperPriceMap = (priceMap) => {
  return priceMap.reduce((acc, arr, index) => {
    if (Array.isArray(arr)) {
      return arr.reduce(
        (ac, prop) => ({...ac, [prop]: priceMap[index + 1][200]}),
        {...acc}
      );
    }
    return acc;
  }, {});
};

const getFormattedPriceMapForVariant = (priceData, variantName) => {
  switch (variantName) {
    case `paper_type`:
      return getFormattedPaperPriceMap(priceData.paper_price_maps);

    case `lamination`:
      return priceData.lamination_per_100;

    case `corner_radius`:
      return priceData.rounded_corners_per_100;
  }

  return void 0;
};

export default getFormattedPriceMapForVariant;
